export const kidWatchTranslations = {
    fa: {
        title: "مقایسه ساعت‌های هوشمند کودکان",
        subtitle: "دلبند",
        description: "ویژگی‌های ساعت‌های هوشمند کودکان دلبند را مقایسه کنید تا بهترین انتخاب را برای فرزند خود داشته باشید.",
    },
    en: {
        title: "Kids Smart Watch Comparison",
        subtitle: "Delband",
        description: "Compare Delband kids smart watch features to make the best choice for your child.",
    },
    ar: {
        title: "مقارنة ساعات الأطفال الذكية",
        subtitle: "دلبند",
        description: "قارن بين ميزات ساعات دلبند الذكية للأطفال لاتخاذ الخيار الأفضل لطفلك.",
    },
    tr: {
        title: "Çocuk Akıllı Saat Karşılaştırması",
        subtitle: "Delband",
        description: "Çocuğunuz için en iyi seçimi yapmak üzere Delband çocuk akıllı saat özelliklerini karşılaştırın.",
    },
};
